// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/Users/jurre/Sites/patronenvanbedrog/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/Users/jurre/Sites/patronenvanbedrog/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/jurre/Sites/patronenvanbedrog/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/Users/jurre/Sites/patronenvanbedrog/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/Users/jurre/Sites/patronenvanbedrog/.cache/json/index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/Users/jurre/Sites/patronenvanbedrog/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/Users/jurre/Sites/patronenvanbedrog/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js